import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/root.reducer';
import { CFCProps, USERSROLE, SCREEN_SIZE } from 'types';
import { MainContainer, MainHeaderContainer } from 'layouts/components';
import {
  AoInfos,
  DbydInfos,
  FooterTile,
  NavTile,
  Map,
  Chart,
  RecentEnquiryTable,
  Controls,
  InfoTile
} from './components';
import {
  APP_URL,
  DashboardEnquirerStatsResponse,
  Params,
  DashboardStatsRequestParams
} from 'types';
import {
  getDashboardEnquirerStatsStart,
  getDashboardAssetOwnerStatsStart,
  getDashboardDBYDStatsStart,
  resetDashboadrdState
} from 'redux/dashboard';
import { addAlert } from 'redux/alerts/actions';
import {
  setForwardEnquiryIsListView,
  fetchEnquiryHistory,
  setForwardEnquiryDateRangeText
} from 'redux/enquiries';
import { fetchReferralHistory } from 'redux/referrals';
import { useComponentMount } from 'utilities/hooks.util';
import { getTimeZone } from 'utilities/helper.util';
import { ContentSwitcher, Switch } from 'carbon-components-react';
import {
  setDashboardUIStateRangeText,
  setDashboardUIStateAdminRangeText,
  setDashboardUIStateShowShape
} from 'redux/dashboard/actions';
import Utils from 'utilities/helper.util';
import { selectAppVisiblePanel } from 'redux/app/selectors';
import { contactSupportFlag } from 'redux/user/actions';
import { setAppVisiblePanel } from 'redux/app/actions';
import { setMapSearchWithExtentZoom } from 'redux/map/actions';
import { selectOrganisationTenants } from 'redux/member/selectors';
import { fetchOrgTenantsStart } from 'redux/member/action';

// Temporary block - need to delete after Helix enabled
import { selectRemedyForceClient } from 'redux/user/selector';
// Temporary block

const getStat = (value: any) => {
  return typeof value === 'number' ? value : 0;
};

const getSwitcherLabel = (role: string | undefined) => {
  if (role === USERSROLE.DBYDADMIN || role === USERSROLE.SYSADMIN) {
    return 'BYDA Admin view';
  }
  return 'Asset owner view';
};

const AdminRoles = [
  USERSROLE.AOADMIN,
  USERSROLE.AOVIEWER,
  USERSROLE.DBYDADMIN,
  USERSROLE.SYSADMIN
];

const defaultRange = 'last-30-days';
const todayDate = Utils.getNewDate().startOf('day').format('YYYY-MM-DD');

export const Dashboard: React.FC<Props | any> = ({
  rawEnquirerStats,
  user,
  screenSize,
  layerExtent,
  rangeText,
  showShape,
  showPoint,
  showGrid,
  mapSearchWithExtentZoom,
  hexbinClassBreaks
}) => {
  const appVisiblePanel: string = useSelector(selectAppVisiblePanel);
  const orgTenants = useSelector(selectOrganisationTenants);
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [startDateAdmin, setStartDateAdmin] = useState<string>(todayDate);
  const [endDateAdmin, setEndDateAdmin] = useState<string>(todayDate);
  const [isLoadingStat, setIsLoadingStat] = useState<boolean>(true);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [showAdminInfo, setShowAdminInfo] = useState<boolean>(false);
  const [showAOAdminInfo, setShowAOAdminInfo] = useState<boolean>(false);
  const [userId, setUserId] = useState<number | undefined>();
  const [userEmail, setUserEmail] = useState<string | undefined>();
  const [organisationId, setOrganisationId] = useState<number | undefined>();
  const [utilityId, setUtilityId] = useState<number | undefined>();
  const [organisationName, setOrganisationName] = useState<
    string | undefined
  >();
  const [tenantId, setTenantId] = useState<number | undefined>();
  const [userRole, setUserRole] = useState<string | undefined>();
  const [
    enquirerStats,
    setEnquirerStats
  ] = useState<DashboardEnquirerStatsResponse>();
  const [rangeTextEnquirer, setRangeTextEnquirer] = useState<string>(
    'last-30-days'
  );
  const [rangeTextAdmin, setRangeTextAdmin] = useState<string>('today');
  const [hasOrgSwitcher, setHasOrgSwitcher] = useState<boolean>(false);
  const dispatch = useDispatch();
  const history = useHistory();

  // Temporary block - need to delete after Helix enabled
  const isRemedyForceClient = useSelector(selectRemedyForceClient);
  // Temporary block

  useEffect(() => {
    if (showAdminInfo) {
      dispatch(setDashboardUIStateRangeText(rangeTextAdmin));
      dispatch(setDashboardUIStateAdminRangeText(rangeTextAdmin));
    } else if (!showAdminInfo) {
      dispatch(setDashboardUIStateRangeText(rangeTextEnquirer));
    }
  }, [showAdminInfo, rangeTextAdmin, rangeTextEnquirer, dispatch]);

  const onClickMyEnquiryLink = () => {
    screenSize !== SCREEN_SIZE.SM &&
      dispatch(setForwardEnquiryIsListView(true));
    dispatch(setForwardEnquiryDateRangeText(rangeText));
    history.push(APP_URL.ENQUIRIY_HISTORY);
  };

  useEffect(() => {
    if (
      ((startDate && endDate) || (startDateAdmin && endDateAdmin)) &&
      userRole
    ) {
      const params: DashboardStatsRequestParams = {
        startDate: showAdminInfo ? startDateAdmin : startDate,
        endDate: showAdminInfo ? endDateAdmin : endDate,
        timezone: getTimeZone()
      };
      dispatch(getDashboardEnquirerStatsStart({ params }));

      if (userRole === USERSROLE.AOADMIN || userRole === USERSROLE.AOVIEWER) {
        dispatch(getDashboardAssetOwnerStatsStart({ params }));
      }

      if (userRole === USERSROLE.DBYDADMIN || userRole === USERSROLE.SYSADMIN) {
        if (userRole === USERSROLE.DBYDADMIN) {
          params.tenantId = tenantId;
        }
        dispatch(getDashboardDBYDStatsStart({ params }));
      }
    }
  }, [
    userRole,
    startDate,
    endDate,
    startDateAdmin,
    endDateAdmin,
    showAdminInfo,
    organisationName,
    tenantId,
    dispatch
  ]);

  useEffect(() => {
    if (rawEnquirerStats) {
      if (typeof rawEnquirerStats === 'string') {
        dispatch(
          addAlert('dashbaord-alert', 'error', 'Error', rawEnquirerStats)
        );
      } else {
        setEnquirerStats(rawEnquirerStats);
        setIsLoadingStat(false);
      }
    } else {
      setIsLoadingStat(true);
    }
  }, [rawEnquirerStats, dispatch]);

  useEffect(() => {
    const queryParams: Params = {
      fields: 'id%2CcreatedAt%2CexternalId%2CuserReference',
      include: 'Address',
      orderBy: '-createdAt',
      limit: 5,
      offset: 0,
      filter: `userId:${userId}`
    };
    userId && dispatch(fetchEnquiryHistory(queryParams));
  }, [dispatch, userId]);

  useEffect(() => {
    if (!showAOAdminInfo) return;

    const todayStart = Utils.getNewDate(`${startDateAdmin}`)
      .utc()
      .startOf('day')
      .format();
    const todayEnd = Utils.getNewDate(`${endDateAdmin}`)
      .utc()
      .endOf('day')
      .format();
    const filter = `createdAfter:${todayStart},createdBefore:${todayEnd}`;

    const queryParams: Params = {
      fields: `id,externalId,createdAt`,
      include: 'Enquiry',
      orderBy: '-createdAt',
      limit: 5,
      offset: 0,
      filter: `organisationId:${organisationId},${filter}`
    };
    (userRole === USERSROLE.AOADMIN || userRole === USERSROLE.AOVIEWER) &&
      organisationId &&
      dispatch(fetchReferralHistory(queryParams));
  }, [
    dispatch,
    startDateAdmin,
    endDateAdmin,
    userRole,
    organisationId,
    showAOAdminInfo
  ]);

  useEffect(() => {
    user?.id && setUserId(user.id);
    user?.email && setUserEmail(user.email);
    user?.organisationId && setOrganisationId(user.organisationId);
    user?.Organisation?.tenantId && setTenantId(user.Organisation.tenantId);
    user?.Organisation?.name && setOrganisationName(user.Organisation.name);
    user?.Organisation?.utilityId && setUtilityId(user.Organisation.utilityId);
    if (user?.role) {
      setUserRole(user.role);
      if (AdminRoles.includes(user.role)) {
        setIsAdmin(true);
      }
      setHasOrgSwitcher(
        user.role === USERSROLE.AOADMIN || user.role === USERSROLE.AOVIEWER
      );
    }
  }, [user]);

  useEffect(() => {
    if (
      user.role === USERSROLE.DBYDADMIN &&
      !user?.Organisation?.tenantId &&
      !Array.isArray(orgTenants)
    ) {
      dispatch(fetchOrgTenantsStart());
    }
  }, [user, orgTenants, dispatch]);

  useEffect(() => {
    if (appVisiblePanel === 'support') {
      dispatch(setAppVisiblePanel(''));

      // Temporary block - need to delete after Helix enabled
      if (
        process.env.REACT_APP_REMEDY_FORCE_ENABLED === 'true' &&
        isRemedyForceClient !== undefined
      ) {
        if (!isRemedyForceClient) {
          dispatch(contactSupportFlag(true));
        } else {
          window.open(
            process.env.REACT_APP_REMEDY_FORCE_SUPPORT_URL,
            '_self',
            'noreferrer'
          );
        }

        return;
      }
      // Temporary block

      dispatch(contactSupportFlag(true));
    }
  }, [dispatch, appVisiblePanel, isRemedyForceClient]);

  useComponentMount(() => {
    return () => {
      dispatch(resetDashboadrdState());
    };
  });

  /**
   * Workaround: Reset to Shapes when navigating back to Dashboard
   *
   * WHY: When user navigates away from Dashboard and returns, the point layer
   * state is not properly preserved, causing points to disappear even though
   * the toggle shows "Points" as selected.
   *
   * HOW: On component mount, if showPoint is true, reset to showShape: true.
   * This ensures the UI state matches the actual map layer visibility.
   */
  useEffect(() => {
    if (showPoint) {
      dispatch(setDashboardUIStateShowShape(true));
    }
    // eslint-disable-next-line
  }, []); // Empty deps - only run on mount

  return (
    <div
      id="dashboard"
      data-testid="dashboard"
      className={`dashboard${isAdmin ? ' is-admin' : ''}${
        showAdminInfo ? ' showing-admin-info' : ''
      }`}
    >
      <div className={`container--wrapper`}>
        <MainHeaderContainer enableHeaderGlobalBar={true} />
        <MainContainer>
          {isAdmin && (
            <div
              className={
                screenSize !== SCREEN_SIZE.SM && !hasOrgSwitcher
                  ? 'dashboard-title-container'
                  : 'dashboard-title-container-sm'
              }
            >
              {screenSize !== SCREEN_SIZE.SM && !hasOrgSwitcher && (
                <div className="dashboard-title">{`${organisationName} ${
                  utilityId ? `(${utilityId})` : ''
                }`}</div>
              )}
            </div>
          )}
          <div className="dashboard-content-container">
            <div className="dashboard-content-left">
              <Controls
                showAdminInfo={showAdminInfo}
                showShapeMap={showShape}
                showPointMap={showPoint}
                showGridMap={showGrid}
                showTenantSelect={
                  showAdminInfo &&
                  user.role === USERSROLE.DBYDADMIN &&
                  !user?.Organisation?.tenantId
                }
                range={rangeText || defaultRange}
                tenantId={tenantId}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                setStartDateAdmin={setStartDateAdmin}
                setEndDateAdmin={setEndDateAdmin}
                setRangeTextEnquirer={setRangeTextEnquirer}
                setRangeTextAdmin={setRangeTextAdmin}
                setTenantId={setTenantId}
              />
              {screenSize !== SCREEN_SIZE.SM && (
                <Map
                  layerExtent={layerExtent}
                  userId={userId}
                  userRole={userRole}
                  range={rangeText || defaultRange}
                  tenantId={tenantId}
                  organisationId={organisationId}
                  showAdminInfo={showAdminInfo}
                  showGridMap={showGrid}
                  showShapeMap={showShape}
                  showPointMap={showPoint}
                  startDate={showAdminInfo ? startDateAdmin : startDate}
                  endDate={showAdminInfo ? endDateAdmin : endDate}
                  mapSearchWithExtentZoom={mapSearchWithExtentZoom}
                  hexbinClassBreaks={hexbinClassBreaks}
                />
              )}
              {userRole !== USERSROLE.AOADMIN &&
                userRole !== USERSROLE.AOVIEWER && (
                  <Chart
                    isLoading={isLoadingStat}
                    range={rangeText || defaultRange}
                    chartData={enquirerStats?.DBYDEnquiries}
                    startDate={startDate}
                  />
                )}
            </div>
            <div className="dashboard-content-right">
              {screenSize !== SCREEN_SIZE.SM && isAdmin && (
                <ContentSwitcher selectedIndex={showAdminInfo ? 0 : 1}>
                  <Switch
                    name={'admin-view'}
                    text={getSwitcherLabel(userRole)}
                    onClick={() => {
                      dispatch(setMapSearchWithExtentZoom([false]));
                      setShowAdminInfo(true);
                      setShowAOAdminInfo(true);
                    }}
                  />
                  <Switch
                    name={'enquirer-view'}
                    text="Enquirer view"
                    onClick={() => {
                      dispatch(setMapSearchWithExtentZoom([false]));
                      setShowAdminInfo(false);
                      setShowAOAdminInfo(false);
                    }}
                  />
                </ContentSwitcher>
              )}
              {showAdminInfo ? (
                <>
                  {userRole === USERSROLE.AOADMIN ||
                  userRole === USERSROLE.AOVIEWER ? (
                    <AoInfos />
                  ) : (
                    <DbydInfos
                      isAADBYD={!user?.Organisation?.tenantId}
                      range={rangeTextAdmin || defaultRange}
                      organisationName={organisationName}
                      startDate={startDateAdmin}
                    />
                  )}
                </>
              ) : (
                <>
                  {screenSize !== SCREEN_SIZE.SM && (
                    <div className="dashboard-content-info-container">
                      <InfoTile
                        isLoading={isLoadingStat}
                        title="My enquiries"
                        value={getStat(enquirerStats?.enquiryCount)}
                        linkLabel="Map"
                        linkAction={onClickMyEnquiryLink}
                        tooltipText={
                          'Total number of enquiries you have lodged in the selected time period'
                        }
                      />
                      <InfoTile
                        isLoading={isLoadingStat}
                        title="Referrals made"
                        value={getStat(enquirerStats?.referralCount)}
                        tooltipText={
                          'Total number of referrals generated from enquiries you have lodged in the selected time period'
                        }
                      />
                    </div>
                  )}
                  {screenSize === SCREEN_SIZE.SM && <NavTile />}
                  <RecentEnquiryTable
                    tooltipText={'Your most recently lodged enquiries'}
                  />
                  {screenSize === SCREEN_SIZE.SM && (
                    <div className="dashboard-content-info-container">
                      <InfoTile
                        isLoading={isLoadingStat}
                        title={'View my enquiries'}
                        value={''}
                        linkLabel="Map"
                        linkAction={onClickMyEnquiryLink}
                        hideValue={true}
                        className="dashboard-component--mobile-view-enquiries"
                        tooltipText={
                          'Total number of enquiries you have lodged in the selected time period'
                        }
                      />
                    </div>
                  )}
                  <Chart
                    isLoading={isLoadingStat}
                    range={rangeText || defaultRange}
                    chartData={enquirerStats?.DBYDEnquiries}
                    startDate={startDate}
                    tooltipText={
                      'Chart of all BYDA enquiries lodged by all users in the selected time period'
                    }
                  />
                  {screenSize !== SCREEN_SIZE.SM && (
                    <div className="dashboard-content-info-container with-nav">
                      <NavTile />
                      <InfoTile
                        isLoading={isLoadingStat}
                        title="BYDA enquiries"
                        value={getStat(enquirerStats?.DBYDEnquiries.total)}
                        tooltipText={
                          'Total number of BYDA enquiries lodged by all users in the selected time period'
                        }
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="dashboard-footer-container">
            <FooterTile
              userId={userId}
              userEmail={userEmail}
              showEmptySpace={
                ![SCREEN_SIZE.MD, SCREEN_SIZE.SM].includes(screenSize)
              }
            />
          </div>
        </MainContainer>
      </div>
    </div>
  );
};

const mapStateToProps = ({ dashboardCache, session, mapCache }: RootState) => ({
  layerExtent: mapCache.featureLayerExtent,
  rawEnquirerStats: dashboardCache.enquirerStats,
  user: session?.currentUser,
  screenSize: session.screenSize,
  rangeText: dashboardCache?.uiSelectionState?.rangeText,
  showShape: dashboardCache?.uiSelectionState?.showShape,
  showPoint: dashboardCache?.uiSelectionState?.showPoint,
  showGrid: dashboardCache?.uiSelectionState?.showGrid,
  mapSearchWithExtentZoom: mapCache.mapSearchWithExtentZoom,
  hexbinClassBreaks: mapCache.hexbinClassBreaks
});

const connector = connect(mapStateToProps);

type Props = CFCProps<typeof connector>;

export default React.memo(connector(Dashboard));
